<!--
Author: Lsc
Date: 2019-07-25
Desc: 修改资料-上传非身份证
 -->
<template>
    <div class="ocr-upd-other-modify comp">
        <el-row class="up-list-other" :span="24">
            <el-form>
                <el-form-item label="">
                    <p class="up-list-mes">本人有效证件照</p>
                    <div class="img-up-box">
                        <el-carousel
                            :interval="4000"
                            type="card"
                            height="200px"
                            :autoplay="playSwitch"
                            :loop="playSwitch"
                            :initial-index="carouselindex"
                        >
                            <el-carousel-item v-for="(data, index) in updData" :key="index">
                                <h3 class="medium">
                                    <div class="img-up-list el-upload-list--picture-card">
                                        <div
                                            v-if="imgBase64[index].front"
                                            class="el-upload-list__item-actions"
                                        >
                                            <i
                                                class="el-icon-zoom-in"
                                                aria-hidden="true"
                                                v-on:click="handlePictureCardPreview(index)"
                                            />
                                            <i
                                                class="el-icon-delete"
                                                aria-hidden="true"
                                                v-on:click="delImg(index)"
                                            />
                                        </div>
                                        <el-input
                                            v-model="data.front"
                                            type="file"
                                            :name="index"
                                            :accept="accept"
                                            v-on:change="getImgBase"
                                        />
                                        <div class="img-up img-load-status">
                                            <img
                                                v-if="imgBase64[index].front"
                                                :src="imgBase64[index].front"
                                                alt=""
                                            />
                                            <img
                                                v-else
                                                :src="require('../../assets/img/ocroverother.png')"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </h3>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </el-form-item>
                <el-form-item label="" class="btn-center">
                    <el-button
                        type="primary"
                        class="medium"
                        :disabled="btnStatus"
                        v-on:click="submitInfo()"
                    >
                        上传
                    </el-button>
                    <el-button class="medium" v-on:click="$router.push({ name: 'modifyinfo' })">
                        还未准备好
                    </el-button>
                </el-form-item>
            </el-form>
            <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "OrcUpdOtherModify",
    props: {
        formdatas: {
            type: Object,
            default: function () {
                return {};
            }
        }
    },
    data() {
        return {
            playSwitch: false,
            dialogImageUrl: "",
            dialogVisible: false,
            accept: "image/bmp,image/png,image/jpg,image/jpeg",
            updData: [],
            imgBase64: [],
            carouselindex: 0,
            upload_url: "acct/ocr/upload"
        };
    },
    computed: {
        btnStatus: function () {
            let valnum = 0;
            this.updData.forEach((item) => {
                valnum = item.front ? valnum++ : valnum;
            });
            return !(valnum > 1);
        }
    },
    created() {
        this.addInitData();
    },
    methods: {
        addInitData() {
            if (this.imgBase64.length === 8) {
                return;
            }
            this.imgBase64.push({ front: "" });
            this.updData.push({ front: "" });
        },
        handlePictureCardPreview(filename) {
            this.dialogImageUrl = this.imgBase64[filename].front;
            this.dialogVisible = true;
        },
        submitInfo() {
            const _this = this;
            const _x = this.$util.src(_this.upload_url, {}, true);
            let b = [];
            _this.imgBase64.forEach((item, index) => {
                if (item.front) {
                    b.push(item.front.substring(item.front.search(",") + 1));
                }
            });
            let _data = {};
            b.forEach((item, index) => {
                switch (index) {
                    case 0:
                        Object.assign(_data, { faceImage: item });
                        break;
                    case 1:
                        Object.assign(_data, { backImage: item });
                        break;
                    case 2:
                        Object.assign(_data, { otherphoto1: item });
                        break;
                    case 3:
                        Object.assign(_data, { otherphoto2: item });
                        break;
                    case 4:
                        Object.assign(_data, { otherphoto3: item });
                        break;
                    case 5:
                        Object.assign(_data, { otherphoto4: item });
                        break;
                    case 6:
                        Object.assign(_data, { otherphoto5: item });
                        break;
                    case 7:
                        Object.assign(_data, { otherphoto6: item });
                        break;
                }
            });
            this.$req({
                method: "POST",
                url: _x,
                timeout: 40000,
                data: _data
            })
                .then((res) => {
                    if (res.code === "0000000") {
                        _this.$cache.refreshUser();
                        const message1 = "上传身份证件成功，";
                        const message2 = "秒后返回信息修改页";
                        this.$handleAutoCloseMessage({
                            type: "success",
                            message1: message1,
                            message2: message2,
                            number: 3,
                            onClose: function () {
                                _this.$router.push({ name: "modifyinfo" });
                            }
                        });
                    } else {
                        _this.$message.error(res.msg);
                    }
                })
                .catch(() => {});
        },
        getImgBase() {
            const _this = this;
            const event = window.event;
            const file = event.target && event.target.files[0];
            let k = 0;
            if (!file) {
                this.delImg(event.target.name);
                return false;
            }
            let maxSize = this.$cache.getOcrFileSize();
            if (file.size > 1024 * 1024 * maxSize) {
                this.updData[event.target.name].front = "";
                this.$message.warning("上传文件大小超过限制大小" + maxSize + "M，不能上传");
                return;
            }
            this.updData.forEach((f) => {
                if (f.front && file.name === f.front.split("\\").pop()) k++;
            });
            if (k === 2) {
                this.delImg(event.target.name);
                this.$message.warning("不能上传相同名称的文件，请重新上传");
                return false;
            }
            const reader = new FileReader();
            // 转base64
            reader.onload = function (e) {
                _this.$set(_this.imgBase64[event.target.name], "front", e.target.result);
            };
            reader.readAsDataURL(file);
            this.addInitData();
            this.carouselindex = this.updData.length - 1;
        },
        // 删除图片
        delImg(index) {
            this.carouselindex = index;
            this.$set(this.imgBase64[index], "front", "");
            this.$set(this.updData[index], "front", "");
        }
        /* delImgEle (index) {
            this.imgBase64.splice(index,1);
            this.updData.splice(index,1);
        } */
    }
};
</script>
<style lang="scss">
.ocr-upd-other-modify {
    .btn-center {
        text-align: center;
    }
    .up-list-other {
        padding: 20px 0;
        .up-list-mes {
            text-align: center;
            font-size: $f22;
            color: $text-color2;
            line-height: 30px;
        }
        .img-up-list {
            margin: 50px 0px;
            display: inline-block;
            position: relative;
            .el-upload-list__item-actions {
                z-index: 100;
                i {
                    font-size: $f24;
                    cursor: pointer;
                }
                i:last-of-type {
                    margin-left: 20px;
                }
            }
            .el-input {
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
                z-index: 10;
            }
            .img-up,
            .el-input .el-input__inner {
                width: 320px;
                height: 150px;
                line-height: 150px;
                cursor: pointer;
            }
            .img-up {
                text-align: center;
                border: 3px dashed $border-color4;
                border-radius: 10px;
                background-color: $bg1;
                overflow: hidden;
                img {
                    width: 320px;
                    height: 150px;
                    display: inline-block;
                }
                &.img-load-status {
                    width: 320px;
                    height: 150px;
                    border: none;
                    border-radius: 6px;
                }
            }
            .img-text {
                vertical-align: middle;
                font-size: $f20;
            }
            .el-icon-plus {
                vertical-align: middle;
                font-size: $f26;
                margin-right: 7px;
                color: inherit;
                font-weight: bold;
            }
        }
        .img-up-box {
            text-align: center;
            .img-up-list {
                vertical-align: middle;
                &:last-of-type {
                    margin-left: 24px;
                }
            }
        }
        .el-form-item__error {
            top: 90%;
            left: 50%;
            -webkit-transform: translateX(-50%);
            -moz-transform: translateX(-50%);
            transform: translateX(-50%);
        }
    }
    .el-carousel.el-carousel--horizontal.el-carousel--card {
        width: 800px;
        margin: auto;
    }
}
#app .ocr-upd-other-modify .el-carousel__button {
    width: 30px;
    height: 2px;
}
</style>
